import React from 'react';

export const LoadingIndicator: React.FC = () => (<div className="loader" data-testid={'loading'}><div className="loader-bar" /></div>);

LoadingIndicator.displayName = 'LoadingIndicator'